module.exports = __webpack_public_path__ + "static/media/Mauritania.945783cd.png";